export const SOCIAL_SECURITY_NUMBER_MASK = '999-99-9999';
